module.exports = __webpack_public_path__ + "img/car-main.00dea51.png";